import React from 'react';
export interface Button2Props {
  text: string;
  customClass?: string;
  link?: string;
}

const Button2: React.FC<Button2Props> = ({ link, customClass, text, ...props }) => {
  const className = `font-medium text-18 p-6 md:text-16 leading-19 md:leading-16  w-160 min-h-44 md:min-h-40 text-textColor bg-white flex justify-center items-center  cursor-pointer border border-disabled rounded-5 ${customClass}`;
  return (
    <>
      {text ? (
        link ? (
          <a
            href={link}
            className={className}
            font-customisation="para-text"
            button-customisation="page-button"
            {...props}
          >
            {text}
          </a>
        ) : (
          <button className={className} font-customisation="para-text" button-customisation="page-button" {...props}>
            {text}
          </button>
        )
      ) : null}
    </>
  );
};

export default Button2;
